import type { FaireProductEntity } from "../../entity_types/product";

export const p_7n5n45ak8r: FaireProductEntity = {
  token: "p_7n5n45ak8r",
  type: "product",
  name: "Wayuu mochila Bag - Handwoven crochet Crossbody Shoulder bag",
  brandToken: "b_rz9qg9uuan",
  brandName: "Coro Cora™",
  imageUrl:
    "https://cdn.faire.com/fastly/b852628039ae2dbe3f48ecdf4961f5dd40f300fd8bfbcd619396f576d34c3663.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3b1b9965964e4035d96fefb4f016f82ba7b0edc2f4c968cd759f0d94c7a1c50d.png",
  ],
  priceDollars: 61.5,
  description:
    "Your ultimate summer accessory! This beautiful and unique mochila bag is handwoven by Wayuu artisans from La Guajira, Colombia.",
  tags: [],
  msrpDollars: 123,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-06T00:00:00.000Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
